import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import Home from './pages/Home'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import 'antd/dist/antd.min.css'
import './styles/Main.scss'
import store from './store'
import Lang from './i18n/index'

//初始化语言部分
if (window.localStorage) {
  let currentLang = localStorage.getItem('lang')
  if (currentLang) {
    Lang._curLang = currentLang
  } else {
    //获取浏览器语言
    const  BrowserDefLang= navigator.systemLanguage
      ? navigator.systemLanguage
      : navigator.language
    let currentLang = 'cn'
    if (BrowserDefLang == 'en-US' || BrowserDefLang == 'en') {
      currentLang = 'us'
    }
    if (BrowserDefLang == 'zh-CN') {
      currentLang = 'cn'
    }
    if (BrowserDefLang == 'zh-TW') {
      currentLang = 'tw'
    }
    //设置默认语言
    localStorage.setItem('lang', currentLang)
    Lang._curLang = currentLang
  }
}

function responsiveSize(e) {
  let width = window.innerWidth
  if (width < 450) width = 450
  document.getElementsByTagName('html')[0].style.fontSize = width / 26.7 + 'px'
  document.getElementsByTagName('body')[0].style.fontSize = width / 26.7 + 'px'
  window.fontSize = width / 26.7
}
responsiveSize()
ReactDOM.render(
  <Provider {...store}>
    <MuiThemeProvider>
      <Home></Home>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js